{
  "health.title": "Portfolio health",
  "health.checks": "Data checks",
  "health.refresh": "Refresh",
  "health.summary": "{count, plural, one {# issue needs attention} other {# issues need attention}}",
  "health.noPortfolios": "No active portfolios in this selection.",
  "health.noIssues": "No issues found in the checked prices, history coverage, FX rates and broker records.",
  "health.checked": "Checked {date} · {count, plural, one {# active portfolio} other {# active portfolios}}",
  "health.types.MissingPrice": "Missing current prices",
  "health.types.StalePrice": "Stale prices",
  "health.types.MissingPriceHistory": "Missing initial price history",
  "health.types.MissingFxRate": "Missing FX rates",
  "health.types.UnmappedInstrument": "Holdings without a price source",
  "health.types.FailedSync": "Failed broker syncs",
  "health.types.BrokerMismatch": "Broker position differences",
  "health.hints.MissingPrice": "These open holdings have no usable current price. Values may use their cost basis.",
  "health.hints.StalePrice": "The price predates the previous weekday. Exchange holidays may also explain an older price.",
  "health.hints.MissingPriceHistory": "No daily close is available on or before the first purchase. This checks the start of history, not every trading day. Review the price source and history coverage.",
  "health.hints.MissingFxRate": "A required conversion has no reference rate within the preceding seven days. Review historical transaction rates and broker imports; current reference rates are refreshed by scheduled jobs.",
  "health.hints.UnmappedInstrument": "Link these holdings to a supported price source so prices and history can be updated.",
  "health.hints.FailedSync": "The latest recorded sync failed for an active connection. Review its settings and sync history, then retry.",
  "health.hints.BrokerMismatch": "The latest reconciliation found quantity differences. Review missing transactions or corporate actions before making corrections.",
  "health.details.MissingPrice": "{symbol}",
  "health.details.StalePrice": "{symbol} · last price {date}",
  "health.details.MissingPriceHistory": "{symbol} · first purchase {date}",
  "health.details.MissingFxRate": "{currency} → {targetCurrency} · first missing {date} · {count, plural, one {# checked date} other {# checked dates}}",
  "health.details.UnmappedInstrument": "{symbol}",
  "health.details.FailedSync": "{connection}",
  "health.details.BrokerMismatch": "{connection} · {count, plural, one {# instrument differs} other {# instruments differ}}",
  "health.actions.MissingPrice": "View instrument",
  "health.actions.StalePrice": "View instrument",
  "health.actions.MissingPriceHistory": "View history",
  "health.actions.MissingFxRate": "Review transactions",
  "health.actions.UnmappedInstrument": "Link price source",
  "health.actions.FailedSync": "Review connection",
  "health.actions.BrokerMismatch": "Reconcile",
  "app.title": "MR Stocks Portfolio Manager",
  "app.buttons.add": "Add",
  "app.buttons.edit": "Edit",
  "app.buttons.delete": "Delete",
  "app.buttons.save": "Save",
  "app.buttons.cancel": "Cancel",
  "app.buttons.close": "Close",
  "app.buttons.ok": "OK",
  "app.buttons.refresh": "Refresh",
  "app.buttons.approve": "Approve",
  "app.buttons.reject": "Reject",
  "app.buttons.sync": "Sync now",
  "app.buttons.archive": "Archive",
  "app.buttons.more": "More actions",
  "app.buttons.retry": "Retry",
  "navigation.dashboard": "Dashboard",
  "navigation.portfolios": "Portfolios",
  "navigation.portfolioHealth": "Portfolio health",
  "navigation.instruments": "Instruments",
  "navigation.corporateActions": "Corporate actions",
  "navigation.watchlist": "Watchlist",
  "navigation.brokers": "Brokers",
  "navigation.instrumentMapping": "Instrument mapping",
  "navigation.admin": "Administration",
  "navigation.openMenu": "Open menu",
  "currency.displayCurrency": "Display currency",
  "theme.switchToDark": "Switch to dark theme",
  "theme.switchToLight": "Switch to light theme",
  "form.selectNone": "None",
  "form.noOptions": "No options",
  "form.loading": "Loading…",
  "form.typeToSearch": "Type to search",
  "form.required": "Required",
  "form.mustBePositive": "Must be greater than zero",
  "table.noRows": "No records",
  "dialogs.confirm.title": "Please confirm",
  "dialogs.deleteConfirm.title": "Delete record",
  "dialogs.deleteConfirm.content": "Do you really want to delete this record? This action cannot be undone.",
  "charts.noData": "No data for the selected period",
  "charts.value": "Value",
  "charts.portfolioReturn": "Portfolio return",
  "charts.benchmark": "Benchmark",
  "charts.periodProfitLoss": "P/L for the period",
  "notifications.saved": "Changes saved",
  "notifications.deleted": "Record deleted",
  "notifications.holdingMoved": "Holding moved",
  "notifications.requestFailed": "Request failed. Please try again.",
  "notifications.validationFailed": "Please check the entered values.",
  "kpi.totalValue": "Total value",
  "kpi.dayChange": "Today",
  "kpi.unrealizedPL": "Unrealized P/L",
  "kpi.realizedPL": "Realized P/L",
  "kpi.dividends": "Dividends",
  "kpi.cash": "Cash",
  "kpi.twrYtd": "TWR YTD",
  "dashboard.title": "Dashboard",
  "dashboard.valueHistory": "Value history",
  "dashboard.portfolios": "Portfolios",
  "dashboard.allocation": "Allocation",
  "dashboard.noPortfolios": "No portfolios yet. Create one on the Portfolios page.",
  "dashboard.noGroupPortfolios": "No active portfolios in this group. Assign portfolios to it on the Portfolios page.",
  "dashboard.portfolioGroup": "Portfolio group",
  "dashboard.allPortfolios": "All portfolios",
  "dashboard.historyModes.value": "Value",
  "dashboard.historyModes.return": "Return %",
  "dashboard.movers": "Top movers today",
  "dashboard.noMovers": "No price changes for your holdings",
  "dashboard.upcomingDividends": "Upcoming dividends",
  "dashboard.noUpcomingDividends": "No upcoming dividends for your holdings",
  "dashboard.dividendPerShare": "Per share",
  "dashboard.expectedAmount": "Expected",
  "portfolios.title": "Portfolios",
  "portfolios.add": "Add portfolio",
  "portfolios.edit": "Edit portfolio",
  "portfolios.archiveConfirm": "Archive this portfolio? It will be hidden from the dashboard.",
  "portfolios.includeArchived": "Show archived",
  "portfolios.archived": "Archived",
  "portfolio.fields.name": "Name",
  "portfolio.fields.baseCurrency": "Base currency",
  "portfolio.fields.benchmark": "Benchmark",
  "portfolio.fields.group": "Group",
  "portfolioGroups.title": "Portfolio groups",
  "portfolioGroups.add": "Add group",
  "portfolioGroups.edit": "Edit group",
  "portfolioGroups.fields.name": "Name",
  "portfolioGroups.portfolioCount": "Active portfolios",
  "portfolioGroups.deleteConfirm": "Delete the group {name}? Its portfolios stay and are left without a group.",
  "portfolio.tabs.positions": "Positions",
  "portfolio.tabs.transactions": "Transactions",
  "portfolio.tabs.dividends": "Dividends",
  "portfolio.tabs.realized": "Realized P/L",
  "portfolio.tabs.allocation": "Allocation",
  "portfolio.tabs.settings": "Settings",
  "portfolio.recalculationPending": "Recalculating values…",
  "positions.symbol": "Symbol",
  "positions.name": "Name",
  "positions.quantity": "Quantity",
  "positions.averageCost": "Avg. cost",
  "positions.lastPrice": "Price",
  "positions.marketValue": "Value",
  "positions.weight": "Weight",
  "positions.dayChange": "Today",
  "positions.unrealizedPL": "P/L",
  "positions.empty": "No open positions",
  "positions.pricePL": "Price P/L",
  "positions.fxImpact": "FX impact",
  "positions.unrealized": "Unrealized",
  "positions.realized": "Realized",
  "positions.dividends": "Dividends",
  "positions.totalPL": "Total P/L",
  "positions.periodPL": "P/L {range}",
  "positions.periodValueChange": "Value change",
  "positions.stalePrice": "Last price is from {date}",
  "positions.noPrice": "No price yet; valued at cost",
  "positions.viewTransactions": "View transactions",
  "positions.moveHolding": "Move to portfolio",
  "positions.moveHoldingHint": "All transactions of this holding, including dividends and fees, move to the chosen portfolio, and both portfolios are recalculated. If the target's base currency is not {baseCurrency}, the trades' own FX rates are replaced by reference rates. New broker trades of this instrument will also go to the chosen portfolio.",
  "positions.move": "Move",
  "positions.targetPortfolio": "Target portfolio",
  "positions.noTransactions": "No transactions for this holding",
  "positions.currentValue": "Current value",
  "positions.valueChange": "Change since trade",
  "transactions.add": "Add transaction",
  "transactions.edit": "Edit transaction",
  "transactions.empty": "No transactions yet",
  "transactions.fxRateHint": "Leave empty to use the reference rate of the trade date",
  "transactions.fxRateSuggestion": "Reference rate of the trade date: {rate}. Leave empty to use it.",
  "transactions.fxRateMissing": "No reference rate for the trade date. Enter the rate.",
  "transactions.useFxRate": "Use",
  "transactions.priceSuggestion": "1-minute opening reference: {price} {currency} at {time} ({source})",
  "transactions.priceHint": "Select an instrument and time. If intraday history is unavailable or the currency differs, enter the execution price.",
  "transactions.priceLoadFailed": "Could not load the intraday reference price. Enter the execution price or change the time to retry.",
  "transactions.tradeTimezone": "Time zone: Europe/Vilnius",
  "transactions.fields.tradeTime": "Date and time",
  "transactions.usePrice": "Use",
  "transactions.fields.type": "Type",
  "transactions.fields.instrument": "Instrument",
  "transactions.fields.tradeDate": "Date",
  "transactions.fields.quantity": "Quantity",
  "transactions.fields.price": "Price",
  "transactions.fields.amount": "Amount",
  "transactions.fields.fee": "Fee",
  "transactions.fields.currency": "Currency",
  "transactions.fields.fxRate": "FX rate to base",
  "transactions.fields.note": "Note",
  "transactions.fields.source": "Source",
  "csvImport.open": "Import CSV",
  "csvImport.title": "Import transactions from CSV",
  "csvImport.chooseFile": "Choose file",
  "csvImport.noFile": "No file chosen",
  "csvImport.delimiter": "Delimiter",
  "csvImport.decimalSeparator": "Decimal separator",
  "csvImport.dateFormat": "Date format",
  "csvImport.hasHeaderRow": "First row has column names",
  "csvImport.delimiters.comma": "Comma (,)",
  "csvImport.delimiters.semicolon": "Semicolon (;)",
  "csvImport.delimiters.tab": "Tab",
  "csvImport.delimiters.pipe": "Pipe (|)",
  "csvImport.decimalSeparators.point": "Point (1.5)",
  "csvImport.decimalSeparators.comma": "Comma (1,5)",
  "csvImport.column": "Column {number}",
  "csvImport.fields.symbol": "Symbol",
  "csvImport.fields.isin": "ISIN",
  "csvImport.fields.externalId": "Transaction ID",
  "csvImport.line": "Line",
  "csvImport.errorsColumn": "Errors",
  "csvImport.noRows": "The file has no data rows",
  "csvImport.statuses.valid": "Ready",
  "csvImport.statuses.duplicate": "Already imported",
  "csvImport.statuses.error": "Error",
  "csvImport.summary": "{valid} ready to import, {duplicates} already imported, {errors} with errors",
  "csvImport.import": "Import {count} rows",
  "csvImport.imported": "Transactions imported",
  "csvImport.errors.tooManyRows": "The file has too many rows (at most 5000)",
  "csvImport.errors.invalidSetting": "Unsupported setting",
  "csvImport.errors.invalidDate": "Date does not match the date format",
  "csvImport.errors.invalidType": "Unknown transaction type",
  "csvImport.errors.invalidNumber": "Not a number",
  "csvImport.errors.instrumentNotFound": "Instrument not found; add it first",
  "csvImport.errors.instrumentAmbiguous": "Several instruments match; add the ISIN or currency",
  "validation.tooLong": "Too long",
  "validation.unsupportedCurrency": "Currency is not supported",
  "validation.unknownInstrument": "Unknown instrument",
  "validation.instrumentNotAllowed": "This transaction type has no instrument",
  "validation.invalidAllocationGrouping": "Unknown allocation grouping",
  "validation.outOfRange": "Value is out of range",
  "validation.unknownPortfolioGroup": "Unknown portfolio group",
  "validation.portfolioGroupNameTaken": "A group with this name already exists",
  "validation.listingTaken": "This listing is already mapped",
  "validation.listingCurrencyMismatch": "This listing is quoted in another currency than the instrument",
  "validation.mergeSameInstrument": "An instrument cannot be merged into itself",
  "validation.mergeIncompatible": "Only instruments with the same currency, type and ISIN can be merged",
  "validation.mergeListingConflict": "Both instruments are linked to the same provider",
  "validation.moveSamePortfolio": "The holding is already in this portfolio",
  "validation.unknownPortfolio": "Unknown portfolio",
  "validation.invalidSplitRatio": "New and old shares must differ",
  "validation.duplicateSplit": "A split on this date already exists",
  "validation.brokerConnectionFailed": "The broker rejected these credentials",
  "transactionTypes.Buy": "Buy",
  "transactionTypes.Sell": "Sell",
  "transactionTypes.Dividend": "Dividend",
  "transactionTypes.Fee": "Fee",
  "transactionTypes.Deposit": "Deposit",
  "transactionTypes.Withdrawal": "Withdrawal",
  "transactionTypes.FxConversion": "FX conversion",
  "transactionTypes.Tax": "Tax",
  "dataProviders.Manual": "Manual",
  "dataProviders.EToro": "eToro",
  "dataProviders.IbkrFlex": "IBKR Flex",
  "dataProviders.IbkrGateway": "IBKR Gateway",
  "dataProviders.Csv": "CSV",
  "dataProviders.Ecb": "ECB",
  "dataProviders.Yahoo": "Yahoo Finance",
  "dividends.empty": "No dividends yet",
  "realized.empty": "No closed lots yet",
  "realized.openDate": "Opened",
  "realized.closeDate": "Closed",
  "realized.cost": "Cost",
  "realized.proceeds": "Proceeds",
  "allocation.groupBy": "Group by",
  "allocation.instrument": "Instrument",
  "allocation.type": "Type",
  "allocation.currency": "Currency",
  "allocation.sector": "Sector",
  "allocation.country": "Country",
  "allocation.notSet": "Not set",
  "instruments.title": "Instruments",
  "instruments.search": "Search by symbol or name",
  "instruments.priceHistory": "Price history",
  "instruments.exchange": "Exchange",
  "instruments.source": "Source",
  "instruments.sources.stored": "Added",
  "instruments.add": "Add instrument",
  "instruments.isin": "ISIN",
  "instruments.sector": "Sector",
  "instruments.country": "Country",
  "instruments.details": "Details",
  "instruments.holdings": "Holdings",
  "instruments.openPage": "Open instrument page",
  "instruments.sentiment.title": "eToro community holdings",
  "instruments.sentiment.buy": "BUY holding percentage (reported)",
  "instruments.sentiment.sell": "SELL holding percentage (reported)",
  "instruments.sentiment.description": "Values are shown as supplied by eToro. Its API does not specify the percentage scale or calculation. These are community holdings data, not analyst recommendations.",
  "instruments.sentiment.unavailable": "eToro community holdings data is unavailable for this instrument.",
  "instruments.sentiment.notReported": "Not reported",
  "instruments.portfolio": "Portfolio",
  "instruments.notHeld": "Not held in any portfolio",
  "corporateActions.title": "Corporate actions",
  "corporateActions.subtitle": "Splits and dividends detected by the daily job. Splits change positions only after approval.",
  "corporateActions.type": "Type",
  "corporateActions.effectiveDate": "Effective date",
  "corporateActions.ratio": "Ratio",
  "corporateActions.amount": "Amount per share",
  "corporateActionTypes.Split": "Split",
  "corporateActions.status": "Status",
  "corporateActions.showPendingOnly": "Pending only",
  "corporateActions.approveConfirm": "Apply this corporate action to {symbol}? Positions and history will be recalculated.",
  "corporateActions.addSplit": "Add split",
  "corporateActions.addSplitHint": "Enter a split the data provider missed. It is applied right away and positions are recalculated.",
  "corporateActions.splitTo": "New shares",
  "corporateActions.splitFrom": "Old shares",
  "corporateActionStatuses.Pending": "Pending",
  "corporateActionStatuses.Applied": "Applied",
  "corporateActionStatuses.Rejected": "Rejected",
  "watchlist.title": "Watchlist",
  "watchlist.add": "Add to watchlist",
  "watchlist.remove": "Remove from watchlist",
  "watchlist.empty": "Watchlist is empty. Find instruments on the Instruments page.",
  "brokers.title": "Broker connections",
  "brokers.subtitle": "Connections used to import transactions and positions",
  "brokers.provider": "Provider",
  "brokers.displayName": "Name",
  "brokers.lastSync": "Last sync",
  "brokers.tokenExpires": "Token expires",
  "brokers.status": "Status",
  "brokers.empty": "No broker connections configured",
  "brokers.editConnection": "Edit connection",
  "brokers.editConnectionHint": "Update the connection settings. Replacement credentials are checked with the broker before saving.",
  "brokers.keepCredentialHint": "Leave blank to keep the saved credential.",
  "brokers.clearApiKey": "Remove the saved API key and use the server's configured key",
  "brokers.isActive": "Connection active",
  "brokers.notLinked": "Not linked to a portfolio",
  "brokers.syncStarted": "Synchronization started",
  "brokers.add": "Add connection",
  "brokers.addHint": "The credentials are checked with the broker and stored encrypted.",
  "brokers.connect": "Connect",
  "brokers.eToroUserKey": "eToro user key",
  "brokers.eToroUserKeyHint": "User key generated in your eToro API key settings",
  "brokers.eToroApiKey": "eToro API key",
  "brokers.eToroApiKeyHint": "Public API key of the same eToro account; leave empty to use the key configured on the server",
  "brokers.flexToken": "Flex token",
  "brokers.flexTokenHint": "Token from the Flex Web Service configuration in IBKR Client Portal",
  "brokers.flexQueryId": "Flex query ID",
  "brokers.tokenExpiresHint": "Shown next to the token in IBKR; used for the expiry warning",
  "brokers.accountNumber": "Account ID",
  "brokers.eToroAccountNumberHint": "Your eToro username",
  "brokers.flexAccountNumberHint": "IBKR account ID, e.g. U1234567",
  "brokers.syncFromDate": "Sync from",
  "brokers.portfolio": "Portfolio",
  "brokers.portfolioHint": "Imported transactions go to this portfolio; an unlinked account is not synced",
  "brokers.includeCfd": "Include CFD trades",
  "brokers.editAccount": "Edit account",
  "brokers.syncRuns": "Sync runs",
  "brokers.syncFinished": "Finished",
  "brokers.delete": "Delete connection",
  "brokers.deleteConfirm": "Delete the connection {name}? Imported transactions stay in their portfolios.",
  "brokers.tokenExpired": "The token has expired. Create a new token and update this connection.",
  "brokers.tokenExpiresSoon": "The token expires on {date}. Renew it before then to keep syncing.",
  "reconciliation.open": "Reconcile",
  "reconciliation.mismatches": "Differences: {count}",
  "reconciliation.mismatchesHint": "Positions differ from the broker as of {date}. Open the reconciliation for details.",
  "reconciliation.title": "Reconciliation",
  "reconciliation.instrument": "Instrument",
  "reconciliation.systemQuantity": "System",
  "reconciliation.brokerQuantity": "Broker",
  "reconciliation.difference": "Difference",
  "reconciliation.reason": "Likely reason",
  "reconciliation.reportedAt": "Broker positions as of",
  "reconciliation.empty": "No positions to compare. Sync the account first.",
  "reconciliationReasons.Matched": "Matched",
  "reconciliationReasons.PendingSplit": "Pending split {ratio}",
  "reconciliationReasons.MissingSplit": "Missing split {ratio}",
  "reconciliationReasons.MissingTransactions": "Missing transactions",
  "reconciliationReasons.ExtraTransactions": "Extra transactions",
  "instrumentMapping.title": "Instrument mapping",
  "instrumentMapping.subtitle": "Link imported instruments to a price source and compare broker positions",
  "instrumentMapping.tabs.unmapped": "Unmapped instruments",
  "instrumentMapping.tabs.reconciliation": "Reconciliation",
  "instrumentMapping.noUnmapped": "All held and watched instruments have a price source",
  "instrumentMapping.suggestions": "Suggestions",
  "instrumentMapping.suggestionCount": "{count, plural, =0 {None} one {# match} other {# matches}}",
  "instrumentMapping.link": "Link",
  "instrumentMapping.linkTitle": "Link instrument",
  "instrumentMapping.linked": "Instrument linked",
  "instrumentMapping.merged": "Instruments merged",
  "instrumentMapping.alreadyLinked": "already linked",
  "instrumentMapping.mergeNotice": "This eToro instrument already belongs to {symbol}. Linking merges {duplicate} into {symbol}: its transactions, listings, watchlist entries and alerts move to {symbol} and {duplicate} is deleted.",
  "instrumentMapping.mergeConfirm": "Merge {duplicate} into {symbol}? This cannot be undone.",
  "instrumentMapping.merge": "Merge",
  "instrumentMapping.suggestion": "eToro instrument",
  "instrumentMapping.suggestionHint": "Pick a suggestion or type a symbol or name to search",
  "instrumentMapping.provider": "Provider",
  "instrumentMapping.externalId": "External ID",
  "instrumentMapping.externalIdHint": "eToro instrument ID, IBKR conid or Yahoo symbol (e.g. IXUA.DE)",
  "instrumentMapping.brokerAccount": "Broker account",
  "instrumentMapping.noLinkedAccounts": "No broker accounts linked to a portfolio",
  "syncStatuses.Succeeded": "Succeeded",
  "syncStatuses.Failed": "Failed",
  "syncStatuses.Running": "Running",
  "admin.title": "Administration",
  "admin.jobs": "Scheduled jobs",
  "admin.apiQuota": "API quota usage",
  "admin.apiCallsToday": "Today: {requests} calls, {failed} failed",
  "admin.jobName": "Job",
  "admin.schedule": "Schedule",
  "admin.lastRun": "Last run",
  "admin.nextRun": "Next run",
  "admin.lastMessage": "Last message",
  "admin.runNow": "Run now",
  "admin.jobStarted": "Job started",
  "admin.syncRuns": "Recent broker syncs",
  "admin.syncStarted": "Started",
  "admin.connection": "Connection",
  "admin.account": "Account",
  "admin.inserted": "Inserted",
  "admin.updated": "Updated",
  "admin.skipped": "Skipped",
  "admin.syncError": "Error",
  "admin.noSyncRuns": "No broker syncs yet",
  "notFound.title": "Page not found",
  "auth.signOut": "Sign out",
  "auth.signInFailed": "Sign-in failed. Please try again.",
  "auth.tryAgain": "Try again",
  "errors.validation": "Please check the entered values.",
  "errors.badRequest": "The request could not be processed.",
  "errors.unauthorized": "Please sign in again.",
  "errors.forbidden": "You do not have access to this data.",
  "errors.notFound": "The requested item was not found.",
  "errors.conflict": "The data was changed by someone else. Please reload and try again.",
  "errors.tooManyRequests": "Too many requests. Please wait a minute and try again.",
  "errors.signInNotAllowed": "This Google account is not allowed to sign in.",
  "errors.signInNotConfigured": "Google sign-in is not configured yet.",
  "errors.unexpected": "Something went wrong. Please reload the page.",
  "ibkrImport.title": "Import IBKR history",
  "ibkrImport.hint": "Choose an IBKR Transaction History CSV. Review the transactions before importing them into the linked portfolio. Missing instruments are created from the CSV trade details when you import. Cash amounts use the report's base currency; trades keep their price currency.",
  "ibkrImport.cashCurrencyHint": "Cash income, taxes and fees are stored in {currency} as reported. This CSV omits their original currency amounts, so cash balances by currency may differ from IBKR. Use a Flex Activity export for exact cash accounting.",
  "ibkrImport.throughDate": "Import through (optional)",
  "ibkrImport.fxReceived": "FX amount received",
  "ibkrImport.syncCoverage": "{count} rows on or after {date} are covered by existing broker history and will be excluded. This import adds earlier history.",
  "ibkrImport.ignored": "{count} FX translation and zero-value rounding adjustments are excluded. They have no cash movements to import.",
  "ibkrImport.imported": "IBKR transactions imported.",
  "ibkrImport.errors.invalidFile": "Choose an IBKR Transaction History CSV containing the base currency and transaction columns.",
  "ibkrImport.errors.accountNotLinked": "Choose an IBKR account linked to a portfolio.",
  "ibkrImport.errors.accountMismatch": "The CSV belongs to a different broker account.",
  "ibkrImport.errors.invalidAmounts": "The amounts or currencies cannot be interpreted safely.",
  "ibkrImport.errors.fixRows": "Resolve the preview errors before importing. No transactions were saved."
}
